import React from 'react';
import { useUser } from '../contexts/UserContext';
import { PageReady } from './lazyPage';

/**
 * An auth request can wait on the network indefinitely. A committed auth loading
 * shell is healthy startup code; do not roll it back because the server is slow.
 * Keep this INSIDE the route Suspense/error boundary so failed or unresolved
 * JavaScript chunks cannot acknowledge readiness.
 */
export default function LiveUpdateStartupReady() {
  const { isLoading } = useUser();
  return isLoading ? <PageReady /> : null;
}
